


















import Vue, { PropType } from 'vue';
// import {
//   Exhibition,
//   exhibition as exhibitionM,
// } from 'mostra';

import {
  OfflineBooth,
} from 'mostra';

export default Vue.extend({
  props: {
    value: {
      type: Array as PropType<OfflineBooth[]>,
      required: true,
    },
  },
  computed: {
    innerValue: {
      get(): string[] {
        const r: string[] = [];
        for (const b of this.value) {
          r.push(`${b.boothId};${b.place}`);
        }
        return r;
      },
      set(val: string[]): void {
        const ls: OfflineBooth[] = [];
        for (const v of val) {
          const ss = v.split(';');
          ls.push({
            boothId: ss[0] || '',
            place: ss[1] || '',
          });
        }
        this.$emit('input', ls);
      },
    },
  },
});
